/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductRolesWithParametersResponseDtoDto } from '../models/pom-product-roles-with-parameters-response-dto-dto';


/**
 * the RoleWithParameters API
 */
@Injectable({
  providedIn: 'root',
})
export class RoleWithParametersService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation productRoleListWithParameters
   */
  static readonly ProductRoleListWithParametersPath = '/product/{productCode}/role/parameters';

  /**
   * Get list of the product roles with parameters by product code
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productRoleListWithParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  productRoleListWithParameters$Response(params: {
    productCode: string;
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductRolesWithParametersResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, RoleWithParametersService.ProductRoleListWithParametersPath, 'get');
    if (params) {
      rb.path('productCode', params.productCode, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductRolesWithParametersResponseDtoDto>;
      })
    );
  }

  /**
   * Get list of the product roles with parameters by product code
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productRoleListWithParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productRoleListWithParameters(params: {
    productCode: string;
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<PomProductRolesWithParametersResponseDtoDto> {

    return this.productRoleListWithParameters$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductRolesWithParametersResponseDtoDto>) => r.body as PomProductRolesWithParametersResponseDtoDto)
    );
  }

}
